/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxCount: NonNullable<unknown> }} Subcategoriesselectupto4Inputs */

const en_subcategoriesselectupto4 = /** @type {(inputs: Subcategoriesselectupto4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sub Categories (select up to ${i?.maxCount})`)
};

const de_subcategoriesselectupto4 = /** @type {(inputs: Subcategoriesselectupto4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unterkategorien (bis zu ${i?.maxCount})`)
};

/**
* | output |
* | --- |
* | "Sub Categories (select up to {maxCount})" |
*
* @param {Subcategoriesselectupto4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const subcategoriesselectupto4 = /** @type {((inputs: Subcategoriesselectupto4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subcategoriesselectupto4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subcategoriesselectupto4(inputs)
	return de_subcategoriesselectupto4(inputs)
});
export { subcategoriesselectupto4 as "subCategoriesSelectUpTo" }